import { useSignal, useComputedQrl, inlinedQrl, useLexicalScope, useTaskQrl } from "@builder.io/qwik";
function useCombinedRef(externalRef, ctxOpts) {
  const internalRef = useSignal();
  const getContextKey = /* @__PURE__ */ inlinedQrl((context, ref) => {
    for (const key in context) {
      if (context[key] === ref)
        return key;
    }
    return void 0;
  }, "useCombinedRef_getContextKey_0MQHt2BuuXU");
  const ctxRefNameSig = useComputedQrl(/* @__PURE__ */ inlinedQrl(async () => {
    const [ctxOpts2, getContextKey2] = useLexicalScope();
    if (!ctxOpts2?.context)
      return;
    return ctxOpts2?.givenContextRef && await getContextKey2(ctxOpts2.context, ctxOpts2.givenContextRef);
  }, "useCombinedRef_ctxRefNameSig_useComputed_UmJYinv7Peo", [
    ctxOpts,
    getContextKey
  ]));
  const contextRefExists = ctxRefNameSig.value !== void 0;
  const contextRef = contextRefExists && ctxOpts?.context?.[ctxRefNameSig.value];
  useTaskQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [contextRef2, ctxOpts2, ctxRefNameSig2, externalRef2, internalRef2] = useLexicalScope();
    if (!externalRef2)
      return;
    if (contextRef2)
      ctxOpts2.context[ctxRefNameSig2.value] = externalRef2;
    else
      internalRef2.value = externalRef2.value;
  }, "useCombinedRef_useTask_pO2IxuIv0ec", [
    contextRef,
    ctxOpts,
    ctxRefNameSig,
    externalRef,
    internalRef
  ]));
  const mergedRef = contextRef ? contextRef : internalRef;
  if (!mergedRef)
    throw new Error("Qwik UI: useCombinedRef could not find the ref. Please pass a ref to the component.");
  return mergedRef;
}
export {
  useCombinedRef
};
